import { faRectangleVerticalHistory } from '@fortawesome/pro-solid-svg-icons';

// eslint-disable-next-line import/no-relative-packages
import { ISummary } from '../../../../universal-dashboard-api/src/Data-Processor/Entities/Interfaces/Summary';
import { formatNumber } from '../../utils/formatters';
import { Card } from './Card';
import { Header } from './Header';

type DataCardProps = {
  data?: ISummary;
  loading?: boolean;
};

type DataCardItemProps = {
  label: string;
  value: string;
  unit?: string;
};

function DataCardItem({ label, value, unit }: DataCardItemProps) {
  return (
    <div key={label} className="border-t border-white border-opacity-80 pt-4">
      <dt className="text-2xl font-bold">
        {value} <span className="text-xl font-normal">{unit}</span>
      </dt>
      <dd className="text-sm">{label}</dd>
    </div>
  );
}

export function DataCard({ data, loading }: DataCardProps) {
  return (
    <Card className="!gap-0">
      <Header
        icon={faRectangleVerticalHistory}
        loading={loading}
        title="Data"
      />
      {!loading && data ? (
        <dl className="grid gap-4 md:grid-cols-3">
          <DataCardItem
            label="processed yesterday"
            value={formatNumber(data.readingsProcessed.size)}
            unit="GB"
          />
          <DataCardItem
            label="readings processed per second"
            value={formatNumber(data.readingsProcessed.second, 0)}
          />
          <DataCardItem
            label="readings processed per day"
            value={formatNumber(data.readingsProcessed.day, 0)}
          />
        </dl>
      ) : (
        <div className="h-10" />
      )}
    </Card>
  );
}
